<template>
<BarChart :data="data" :options="options" style="height:200px"></BarChart>
</template>

<script>
import BarChart from '@/components/chart/BarChart'
import DataChartDialog from '@/components/chart/DataChartDialog'

export default {
  name: 'MotionChart',
  mixins: [DataChartDialog],
  components: {
    BarChart
  },
  computed: {
    data() {
      return {
        datasets: [{
          data: Object.keys(this.histogramData).map(t => ({
            t: parseInt(t),
            y: this.histogramData[t]
          })),
          borderWidth: 1.5,
          lineTension: 0,
          pointRadius: 0.5,
          fill: false,
          borderColor: this.$vuetify.theme.currentTheme.primary,
          backgroundColor: this.$vuetify.theme.currentTheme.primary
        }]
      };
    },
    options() {
      return {
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            type: 'time',
            maxBarThickness: 36,
            time: {
              max: (~~(this.timestamp / this.interval) + 1) * this.interval
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: 0,
              suggestedMin: 0
            },
            scaleLabel: {
              display: !!this.unit,
              labelString: this.unit
            }
          }]
        },
        tooltips: {
          intersect: false,
          mode: 'index',
          axis: 'x'
        },
        responsive: true,
        maintainAspectRatio: false,
        animation: false
      };
    },
    dataCount() {
      return 500;
    },
    interval() {
      return 30 * 60 * 1000;
    },
    histogramData() {
      return Object.keys(this.rawData || {}).reduce((a, t) => {
        let ti = ~~(t / this.interval) * this.interval;
        let rd = this.rawData[t];
        if (rd && rd.motionState == 'DETECTED') {
          a[ti] = (a[ti] || 0) + 1;
        }
        return a;
      }, {});
    }
  }
}
</script>
